export const PHONE_DISPLAY = "(31)3826-4166";
export const PHONE_TEL = "(31)3826-4166";
export const PHONE2_DISPLAY = "(31) 98270-2314";
export const WHATSAPP_NUMBER = "(31) 98270-2314";
export const CITY = "Ipatinga";

export const LOGO_WHITE = "/logo-white.png";
export const LOGO_BLUE = "/logo-blue.png";
export const ABOUT_IMAGE =
  "https://customer-assets.emergentagent.com/job_first-phase/artifacts/roj088jj_Captura%20de%20tela_26-6-2026_92655_bahiagasipatinga.com.br.jpeg";
export const EMAIL = "contato@bahiagasipatinga.com.br";
export const EMAIL_FINANCEIRO = "bahiagasfinanceiro@gmail.com";
export const COMPANY_NAME = "Bahia Comercial Ltda";
export const CNPJ = "00.333.175/0001-10";
export const INSTAGRAM_HANDLE = "@bahiagasipatinga";
export const INSTAGRAM_URL = "https://instagram.com/bahiagasipatinga";
export const ADDRESS_LINES = [
  "Rua Passo Fundo, 760",
  "Bairro Caravelas",
  "Ipatinga - MG",
  "CEP 35164-279",
];
export const HOURS = ["Segunda-feira a Sábado: 7h às 21h", "Domingo: fechado"];
export const SCHEDULE = "Segunda-feira a Sábado: 7h às 21h e Domingo: fechado.";

export const INSTAGRAM_REEL_URL = "https://www.instagram.com/reel/DZmx_mMJkzL/";
export const INSTAGRAM_REEL_EMBED = "https://www.instagram.com/reel/DZmx_mMJkzL/embed";

export const VIDEO = {
  title: "Veja como o Gás é colocado no botijão.",
  channel: "Bahia Gás Ipatinga",
  caption: "Assista à nossa dica de segurança",
  videoId: "uADCohB1b68",
  youtubeUrl: "https://youtu.be/uADCohB1b68",
  embedUrl: "https://www.youtube.com/embed/uADCohB1b68?autoplay=1&rel=0",
  thumb: "https://img.youtube.com/vi/uADCohB1b68/maxresdefault.jpg",
};

export const openWhatsApp = () => {
  window.location.href = "https://wa.me/message/T7AHHEA3XPPPI1";
};
export const NAV_LINKS = [
  { label: "Início", href: "#inicio" },
  { label: "Sobre", href: "#sobre" },
  { label: "Produtos", href: "#produtos" },
  { label: "Dicas", href: "#dicas" },
  { label: "FAQ", href: "#faq" },
  { label: "Contato", href: "#contato" },
];

export const STATS = [
  { icon: "Flame", value: "+33", label: "Anos de experiência" },
  { icon: "Users", value: "10K+", label: "Clientes atendidos" },
  { icon: "Award", value: "100%", label: "Qualidade garantida" },
  { icon: "Clock", value: "7h–21h", label: "Seg. a Sáb." },
];

export const HERO_BG =
  "https://customer-assets.emergentagent.com/job_first-phase/artifacts/98dz2ewq_Captura%20de%20tela_26-6-2026_9406_bahiagasipatinga.com.br.jpeg";

export const PRODUCTS = [
  {
    id: "p13",
    name: "Gás GLP P13 – 13 kg",
    badge: "Mais vendido",
    image:
      "https://customer-assets.emergentagent.com/job_first-phase/artifacts/3t7wa6jv_but%201.jpg",
    description:
      "O botijão residencial mais popular. Ideal para uso doméstico em fogões e fornos. Qualidade e segurança Ultragaz.",
    tags: ["Residencial", "13 kg", "Ultragaz"],
  },
  {
    id: "p20",
    name: "Gás GLP P45 – 45 kg",
    badge: null,
    image:
      "https://customer-assets.emergentagent.com/job_first-phase/artifacts/6i602jmr_but%202.jpg",
    description:
      "Capacidade intermediária para quem tem maior demanda. Perfeito para comércios e residências com alto consumo.",
    tags: ["Comercial", "45 kg", "Ultragaz"],
  },
  {
    id: "p45",
    name: "Gás GLP P20 – 20 kg",
    badge: "Industrial",
    image:
      "https://customer-assets.emergentagent.com/job_first-phase/artifacts/hhn124ef_but%203.jpg",
    description:
      "Solução industrial para empresas e grandes estabelecimentos. Máxima duração e eficiência para o seu negócio.",
    tags: ["Industrial", "20 kg", "Ultragaz"],
  },
  {
    id: "agua",
    name: "Água Mineral – 20 Litros",
    badge: null,
    image:
      "https://static.prod-images.emergentagent.com/jobs/481e19e7-4e39-4659-a83e-59f57ce64e8a/images/ca7267ffc75ea88d8f21eee5e732de65fb52bebfe8e87a872c1cfe827a1d62ab.png",
    description:
      "A mais pura água mineral disponível no mercado. Garrafão de 20L com entrega rápida em Ipatinga.",
    tags: ["Água mineral", "20 litros", "Entrega"],
  },
  {
    id: "valvula",
    name: "Kit Regulador + Mangueira",
    badge: "Acessório",
    image: "/valvula.png",
    description:
      "Kit completo com regulador de pressão, mangueira certificada e abraçadeiras. Tudo para instalar seu botijão com total segurança.",
    tags: ["Regulador", "Mangueira", "Segurança"],
  },
];

export const TIPS = [
  {
    icon: "ShieldCheck",
    color: "indigo",
    title: "Instalação segura",
    text: "Sempre instale o botijão em área ventilada, longe de fontes de calor e fora do alcance de crianças.",
  },
  {
    icon: "Wrench",
    color: "green",
    title: "Manutenção da mangueira",
    text: "Verifique a data de validade da mangueira e do regulador de pressão. Troque a cada 5 anos.",
  },
  {
    icon: "AlertTriangle",
    color: "red",
    title: "Detectando vazamentos",
    text: "Use água com sabão nas conexões. Se borbulhar, há vazamento. Nunca use fósforo ou isqueiro para testar.",
  },
  {
    icon: "Flame",
    color: "indigo",
    title: "Chama correta",
    text: "A chama ideal é azul e firme. Se estiver amarelada ou oscilando, chame um técnico especializado.",
  },
  {
    icon: "Wind",
    color: "green",
    title: "Ventilação adequada",
    text: "Mantenha sempre uma ventilação natural no ambiente onde o botijão está instalado.",
  },
  {
    icon: "BadgeCheck",
    color: "indigo",
    title: "Compra segura",
    text: "Compre sempre de revendedores autorizados. Verifique o lacre, a data de validade e o selo de qualidade.",
  },
];

export const FAQS = [
  {
    q: "Como faço para pedir gás?",
    a: "É muito simples! Basta clicar em qualquer botão de WhatsApp do site ou ligar para o nosso telefone. Informe seu endereço e o produto desejado que entregamos rapidinho.",
  },
  {
    q: "Qual a área de entrega?",
    a: "Realizamos entregas em toda a cidade de Ipatinga e região do Vale do Aço, com rapidez e segurança.",
  },
  {
    q: "Como saber se o botijão está com defeito?",
    a: "Verifique se há cheiro de gás, chiado ou ferrugem no botijão. Use água com sabão nas conexões: se borbulhar, há vazamento. Em caso de dúvida, entre em contato conosco imediatamente.",
  },
  {
    q: "Qual a validade da mangueira do gás?",
    a: "A mangueira e o regulador de pressão devem ser trocados a cada 5 anos. Sempre confira a data de validade impressa no produto.",
  },
  {
    q: "Vocês vendem gás industrial?",
    a: "Sim! Trabalhamos com o botijão GLP P45 (45 kg), ideal para empresas, indústrias e grandes estabelecimentos com alto consumo.",
  },
  {
    q: "A água mineral tem certificação?",
    a: "Sim. Nossa água mineral de 20 litros é certificada, lacrada e segue todos os padrões de qualidade e segurança do mercado.",
  },
];
